import { isDateEarlier, isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getCharMinMessage,
    getDateMinMessage,
    getDateMinOrSameMessage,
    getNowDateOrEarlierMessage,
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const MIN_OTHER_DETAIL_CHAR = 5;

export const validate = (
    newEntry,
    initialRow,
    formType,
    otherSideEffectEventTypeId,
    otherAdverseEventEventTypeId
) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.healthEventTypeIds?.length) {
        newErrors = {
            ...newErrors,
            healthEventTypeIds: { error: true, message: getSelectMessage('event type', 'at least one') }
        };
    }

    if (newEntry?.healthEventTypeIds?.length && newEntry.healthEventTypeIds.includes(otherSideEffectEventTypeId)) {
        let error = false;
        let message = '';
        if (!newEntry.sideEffectsDetail) {
            error = true;
            message = getReqMessage('Other - Side Effect detail');
        } else if (newEntry.sideEffectsDetail.trim().length < MIN_OTHER_DETAIL_CHAR) {
            error = true;
            message = getCharMinMessage('Other - Side Effect detail', MIN_OTHER_DETAIL_CHAR);
        }
        if (error) newErrors = { ...newErrors, sideEffectsDetail: { error, message } };
    }

    if (newEntry?.healthEventTypeIds?.length && newEntry.healthEventTypeIds.includes(otherAdverseEventEventTypeId)) {
        let error = false;
        let message = '';
        if (!newEntry.adverseEventsDetail) {
            error = true;
            message = getReqMessage('Other - Adverse Event detail');
        } else if (newEntry.adverseEventsDetail.trim().length < MIN_OTHER_DETAIL_CHAR) {
            error = true;
            message = getCharMinMessage('Other - Adverse Event detail', MIN_OTHER_DETAIL_CHAR);
        }
        if (error) newErrors = { ...newErrors, adverseEventsDetail: { error, message } };
    }

    if (newEntry.dateReportedToNhse) {
        let error = false;
        let message = '';
        if (isDateFuture(newEntry.dateReportedToNhse)) {
            error = true;
            message = getNowDateOrEarlierMessage();
        } else if (isDateEarlier(newEntry.eventDate, newEntry.dateReportedToNhse)) {
            error = true;
            message = getDateMinOrSameMessage('event date');
        }
        if (error) newErrors = { ...newErrors, dateReportedToNhse: { error, message } };
    }

    if (newEntry.programmeDeIntensifiedDate && isDateFuture(newEntry.programmeDeIntensifiedDate)) {
        newErrors = {
            ...newErrors,
            programmeDeIntensifiedDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (newEntry.programmeReIntensifiedDate) {
        let error = false;
        let message = '';
        if (isDateFuture(newEntry.programmeReIntensifiedDate)) {
            error = true;
            message = getNowDateOrEarlierMessage();
        } else if (
            !isDateEarlier(newEntry.programmeReIntensifiedDate, newEntry.programmeDeIntensifiedDate)
        ) {
            // can't be same day either
            error = true;
            message = getDateMinMessage('de-intensified date');
        }
        if (error) newErrors = { ...newErrors, programmeReIntensifiedDate: { error, message } };
    }

    if (newEntry.fibreSupplementDate) {
        let error = false;
        let message = '';
        if (isDateFuture(newEntry.fibreSupplementDate)) {
            error = true;
            message = getNowDateOrEarlierMessage();
        } else if (
            !isDateEarlier(newEntry.fibreSupplementDate, newEntry.programmeDeIntensifiedDate)
        ) {
            // can't be same day either
            error = true;
            message = getDateMinMessage('de-intensified date');
        }
        if (error) newErrors = { ...newErrors, fibreSupplementDate: { error, message } };
    }
    if (formType === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialRow);
    }

    return newErrors;
};
